<template>
  <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer">Configuraciones</a>
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3">Canales de Venta</span>
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <Toast />
    <div class="flex align-items-start flex-column lg:justify-content-between lg:flex-row">
      <div>
        <div class="font-medium text-3xl text-900">
          Administrar Canales de Venta
        </div>
      </div>
      <div class="flex mt-3 lg:mt-0">
        <Button
          label="Nuevo"
          v-tooltip.top="'Nuevo Canal'"
          icon="pi pi-plus"
          class="p-button-outlined mr-2 p-button-lg"
          @click="abrirModalCrear"
        />
      </div>
    </div>
    <div class="mt-4">
      <CustomDataTable
        :datos="canalesVenta"
        :cargando="cargando"
        nombreEntidad="CanalVentas"
        :columnas="columnTable"
      >
        <!-- Slot personalizado para formatear el 'estado' -->
        <template #estado="{ data }">
          <Badge :value="data.estado.label" :severity="data.estado.value === 1 ? 'success' : 'danger'" />
        </template>
        
        <!-- Slot para el menú de acciones -->
        <template #acciones="{ data }">
          <Button
            class="p-button-icon-only p-button-raised"
            icon="pi pi-ellipsis-v"
            @click="$refs['menu' + data.id].toggle($event)"
          />
          <Menu :ref="'menu' + data.id" :popup="true" :model="acciones(data)" />
        </template>
      </CustomDataTable>
    </div>
    
    <Dialog
      v-model:visible="deleteCanalDialog"
      :style="{ width: '450px' }"
      header="Confirmar"
      :modal="true"
    >
      <div class="flex align-items-center justify-content-center">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span v-if="canalParaModal"
          >¿Estás seguro de que deseas eliminar el canal
          <b>{{ canalParaModal.nombre }}</b> ?</span
        >
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          class="p-button-secondary"
          @click="deleteCanalDialog = false"
        />
        <Button
          label="Sí"
          icon="pi pi-check"
          class="p-button-primary"
          @click="confirmDeleteCanal"
        />
      </template>
    </Dialog>
  </div>
  
  <CanalVentaCreate
    :show="mostrarModal"
    :canal="canalParaModal"
    @closeModal="cerrarModal"
    @actualizarListado="cargarCanalesVenta"
  />
</template>

<script>
import CanalVentaService from "@/service/CanalVentaService";
import { useAuth } from "@/stores";
import CustomDataTable from '@/components/shared/CustomDataTable.vue';
import CanalVentaCreate from './CanalVentaCreate.vue';

export default {
  components: {
    CustomDataTable,
    CanalVentaCreate
  },
  data() {
    return {
      canalesVenta: [],
      cargando: false,
      mostrarModal: false,
      deleteCanalDialog: false,
      canalParaModal: null,
      columnTable : [
        { field: "id", header: "CÓDIGO", sortable: true },
        { field: "nombre", header: "NOMBRE", sortable: true },
        { field: "estado", header: "ESTADO", sortable: true }
      ]
    };
  },
  canalVentaService: null,
  auth: null,
  created() {
    this.auth = useAuth();
    this.canalVentaService = new CanalVentaService();
  },
  mounted() {
    this.cargarCanalesVenta();
  },
  methods: {
    acciones(datos) {
      let permisosUsuarioAuth = this.auth.user.permissions;
      return [
        {
          label: "Editar",
          disabled: "CanalVenta Editar" in permisosUsuarioAuth ? false : true,
          icon: "pi pi-pencil",
          command: () => {
            this.editarCanal(datos);
          },
        },
        {
          label: "Eliminar",
          disabled: "CanalVenta Eliminar" in permisosUsuarioAuth ? false : true,
          icon: "pi pi-trash",
          command: () => {
            this.eliminarCanal(datos);
          },
        },
      ];
    },
    textoEstado(estado) {
      return estado == 1 ? "Activo" : "Inactivo";
    },
    cargarCanalesVenta() {
      this.cargando = true;
      this.canalVentaService.getCanalesVenta().then((data) => {
        this.canalesVenta = data.canalventa || [];
        this.canalesVenta.forEach((canal) => {
          canal.estado = {
            label: this.textoEstado(canal.estado),
            value: canal.estado,
          };
        });
        this.cargando = false;
      }).catch(error => {
        this.cargando = false;
        console.error(error);
      });
    },
    abrirModalCrear() {
      this.canalParaModal = null;
      this.mostrarModal = true;
    },
    cerrarModal() {
      this.mostrarModal = false;
      this.canalParaModal = null;
    },
    editarCanal(canal) {
      this.canalParaModal = { ...canal };
      this.mostrarModal = true;
    },
    eliminarCanal(canal) {
      this.canalParaModal = { ...canal };
      this.deleteCanalDialog = true;
    },
    async confirmDeleteCanal() {
      try {
        this.cargando = true;
        await this.canalVentaService.deleteCanalVenta(this.canalParaModal.id);
        this.$toast.add({ severity: 'success', summary: 'Éxito', detail: 'Canal eliminado', life: 3000 });
        this.cargarCanalesVenta();
      } catch (error) {
        console.error(error);
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo eliminar el canal', life: 3000 });
      } finally {
        this.cargando = false;
        this.deleteCanalDialog = false;
        this.canalParaModal = null;
      }
    }
  }
};
</script>
